import { useQuery } from "@tanstack/react-query";

import { customAxios } from "lib/axios";
import { User } from "types";
import { refetchUserOnError } from "utils/refetchUserOnError";
import { useQueryClient } from "@tanstack/react-query";

export type PaginationData = {
  page: number;
  limit: number;
  total: number;
  pages: number;
  hasMore: boolean;
};

export type ScopedUsersListResponse = {
  success: boolean;
  data: User<string>[];
  pagination: PaginationData;
};

const getScopedUsersList = async (
  page = 1,
  limit = 10,
  email?: string
): Promise<ScopedUsersListResponse> => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (email) {
    params.append("q", email);
  }

  const { data } = await customAxios.get<ScopedUsersListResponse>(
    `/users/scoped-list?${params.toString()}`
  );

  return {
    ...data,
    pagination: {
      ...data.pagination,
      hasMore: data.pagination.page < data.pagination.pages,
    },
  };
};

export const useGetScopedUsersList = (
  page = 1,
  limit = 10,
  email?: string
) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["scoped-users", page, limit, email],
    queryFn: () => getScopedUsersList(page, limit, email),
    keepPreviousData: true,
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
